export default "/images/arrow.svg?62fa00d3411d680f8a485bdcca57310c";